<div class="row">
    <div class="col-md-4">
        <label>Customer:</label>
    </div>
    <div class="col-md-6">
        <div>{{ currentUser ? currentUser.firstName : '' }} {{currentUser ? currentUser.lastName : '' }}</div>
    </div>
</div>
<div class="row">
    <div class="col-md-4">
        <label>Phone:</label>
    </div>
    <div class="col-md-6">
        <div>{{currentUser ? currentUser.phone : '' }}</div>
    </div>
</div>
<div class="row">
    <div class="col-md-4">
        <label>User Id:</label>
    </div>
    <div class="col-md-6">
        <div>{{currentUser ? currentUser.id : '' }}</div>
    </div>
</div>
<div class="row">
    <div class="col-md-4">
        <label>Email:</label>
    </div>
    <div class="col-md-6">
        <div>{{currentUser ? currentUser.email : '' }}</div>
    </div>
</div>